import { render, staticRenderFns } from "./DevTypeCounts.vue?vue&type=template&id=6e866b4e"
import script from "./DevTypeCounts.vue?vue&type=script&lang=js"
export * from "./DevTypeCounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports